import { IMessageModel } from "../message-panel/message-panel.models";

export class ModalSettings {
    header: string;
    text: string;
    yesCaption: string;
    okCaption: string;
    noCaption: string;
    yesDisabled = false;
    centered = false;
    contentIsMarkup = false;
    windowClass: string = null;
    messages: IMessageModel[] = [];
    constructor(header: string, text: string) {
        this.header = header;
        this.text = text;
        this.okCaption = "Ok";
        this.yesCaption = "Ja";
        this.noCaption = "Nej";
    }

}
